import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ApplyComplete() {
  const navigate = useNavigate();

  const onClickClose = () => {
    window.close();
  };

  return (
    <div className="uk-flex uk-flex-column uk-flex-middle">
      <div className="sub-header">
        <p className="uk-text-large uk-text-bold">DRM-PF問合せ　送信完了</p>
      </div>
      <div className="uk-flex uk-width-3-4 uk-margin-top">
        <div className="step-content">
          <ul className="step">
            <li>メールアドレスの入力</li>
            <li>メールアドレスの送信完了</li>
            <li>お客様情報の登録</li>
            <li>登録内容の確認</li>
            <li className="is-current">お申し込みの完了</li>
          </ul>
        </div>
      </div>
      <div className="uk-flex uk-flex-column uk-flex-middle uk-width-3-4 uk-margin-large-top">
        <p className="uk-text-large uk-text-bold uk-text-center uk-margin-bottom">
          フォームからのお申し込みが完了しました。
        </p>
        <p className="uk-text-medium uk-margin-bottom uk-text-center">
          受付完了のメールをお送りしました。
        </p>
        <br/>
        <br/>
        <p className="uk-text-center">
          ※ 閉じるボタンが利かない場合はブラウザを閉じてください。
        </p>
        <button
            className="uk-button--m uk-button-cancel uk-margin-top"
            onClick={onClickClose}
        >
          閉じる
        </button>
      </div>
    </div>
  );
}
